/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.PortalAuthenticateResponse | undefined,
  (value: vp.PortalAuthenticateRequest) => void,
  () => void,
  (requestParams: vp.PortalAuthenticateRequest) => Promise<vp.PortalAuthenticateResponse>,
];

function usePostPortalAuthenticate({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.PortalAuthenticateRequest>();
  const [response, setResponse] = useState<vp.PortalAuthenticateResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.PortalAuthenticateRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postPortalAuthenticate(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.PortalAuthenticateRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
    async (requestParams: vp.PortalAuthenticateRequest) => {
      try {
        setDataFetchingInfo(true);
        const res = await api.postPortalAuthenticate(requestParams, source);

        return res;
      } catch (err) {
        console.error(err);

        throw err;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPortalAuthenticate);
